import React from 'react';
import { Radio, Volume2, Play, Pause } from 'lucide-react';
import './RadioAlarm.css';

export default function RadioAlarm({
  alarmHour,
  alarmMinute,
  snoozeMinutes,
  selectedMelody,
  growing,
  alarmActive,
  alarmRinging,
  timeLeft,
  setAlarmHour,
  setAlarmMinute,
  setSnoozeMinutes,
  setSelectedMelody,
  setGrowing,
  setAlarmActive,
  stopAlarm,
  snoozeAlarm,
  testSound,
  // 收音机相关 props
  selectedStation,
  setSelectedStation,
  volume,
  setVolume,
  isPlaying,
  radioStations,
  playRadio,
  stopRadio,
  testRadio
}) {
  const handleStopAlarm = () => {
    stopRadio();
    stopAlarm(); // 使用传入的stopAlarm函数
  };

  return (
    <div className="space-y-6">
      <div className="bg-cyan-600/40 backdrop-blur-md rounded-3xl p-8 border border-cyan-400/30 shadow-2xl">
        <div className="flex items-center gap-3 mb-6">
          <Radio className="w-8 h-8 text-white" />
          <h3 className="text-2xl font-bold text-white">Radio Alarm Clock</h3>
        </div>

        <p className="text-white/80 mb-6">
          Wake up to your favorite radio station from around the world.
        </p>

        {/* Time Settings */}
        <div className="grid md:grid-cols-2 gap-6 mb-6">
          <div>
            <label className="block text-white font-semibold mb-3 text-lg">
              When alarm?
            </label>
            <div className="flex gap-3">
              <select
                value={alarmHour}
                onChange={(e) => setAlarmHour(e.target.value)}
                className="flex-1 px-4 py-3 bg-white/90 rounded-xl text-gray-700 font-semibold text-xl focus:outline-none focus:ring-2 focus:ring-cyan-400"
              >
                {Array.from({ length: 24 }, (_, i) => (
                  <option key={i} value={i.toString().padStart(2, '0')}>
                    {i.toString().padStart(2, '0')}
                  </option>
                ))}
              </select>
              <select
                value={alarmMinute}
                onChange={(e) => setAlarmMinute(e.target.value)}
                className="flex-1 px-4 py-3 bg-white/90 rounded-xl text-gray-700 font-semibold text-xl focus:outline-none focus:ring-2 focus:ring-cyan-400"
              >
                {Array.from({ length: 60 }, (_, i) => (
                  <option key={i} value={i.toString().padStart(2, '0')}>
                    {i.toString().padStart(2, '0')}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div>
            <label className="block text-white font-semibold mb-3 text-lg">
              Volume: {volume}%
            </label>
            <input
              type="range"
              min="0"
              max="100"
              value={volume}
              onChange={(e) => setVolume(Number(e.target.value))}
              className="w-full h-3 bg-white/30 rounded-lg appearance-none cursor-pointer"
            />
          </div>
        </div>

        {/* Radio Station Selection */}
        <div className="mb-6">
          <label className="block text-white font-semibold mb-3 text-lg">
            Choose Radio Station
          </label>
          <div className="flex gap-3 items-center">
            <select
              value={selectedStation}
              onChange={(e) => setSelectedStation(e.target.value)}
              className="flex-1 px-4 py-3 bg-cyan-700/60 text-white rounded-xl font-semibold text-lg focus:outline-none focus:ring-2 focus:ring-cyan-400"
            >
              <option value="">Select a station...</option>
              {radioStations.map(station => (
                <option key={station.id} value={station.id}>
                  {station.name} - {station.genre}
                </option>
              ))}
            </select>
            <button
              onClick={testRadio}
              disabled={!selectedStation}
              className="p-3 bg-cyan-500 hover:bg-cyan-600 disabled:bg-gray-500 disabled:cursor-not-allowed rounded-xl transition-colors"
            >
              {isPlaying ? <Pause className="w-6 h-6 text-white" /> : <Play className="w-6 h-6 text-white" />}
            </button>
          </div>
        </div>

        {/* Action Buttons */}
        {!alarmRinging ? (
          <button
            onClick={() => setAlarmActive(!alarmActive)}
            disabled={!selectedStation}
            className={`w-full py-4 rounded-xl font-bold text-lg transition-colors shadow-lg disabled:bg-gray-500 disabled:cursor-not-allowed ${
              alarmActive
                ? 'bg-green-600 hover:bg-green-700 text-white'
                : 'bg-cyan-500 hover:bg-cyan-600 text-white'
            }`}
          >
            {alarmActive ? '✓ Radio Alarm Set' : 'Set Radio Alarm'}
          </button>
        ) : (
          <button
            onClick={handleStopAlarm}
            className="w-full py-4 bg-red-800 hover:bg-red-900 text-white rounded-xl font-bold text-lg transition-colors shadow-lg flex items-center justify-center gap-2"
          >
            <Volume2 className="w-6 h-6 animate-bounce" />
            Stop Radio Alarm
          </button>
        )}

        {/* Status Messages */}
        {alarmActive && !alarmRinging && (
          <div className="mt-4 bg-green-100 border-2 border-green-500 rounded-lg p-4">
            <p className="text-green-800 font-semibold">
              Radio alarm set for {alarmHour}:{alarmMinute}
            </p>
            <p className="text-green-600 text-sm mt-1">
              Time left: {timeLeft}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}